import { render } from "./StarterEvent.vue?vue&type=template&id=b6c639be"
import script from "./StarterEvent.vue?vue&type=script&lang=js"
export * from "./StarterEvent.vue?vue&type=script&lang=js"
script.render = render

export default script